<template>
  <image-list :list="list" />
</template>

<script>
import ImageList from "@/components/ImageList.vue";

export default {
  name: "kirker",
  components: {
    ImageList
  },
  data() {
    return {
      list: [
        {
          id: 1,
          type: "LeftRight",
          leftImage: "/images/kirker/1/left.jpg",
          leftImageHeight: 450,
          rightImage: "/images/kirker/1/right.jpg",
          rightImageHeight: 450,
          leftText: "VÅBENHUS SKRYDSTRUP KIRKE 2000",
          rightText: "BRONZESKULPTUR BÆNK DØRGREB BILLEDHUGGER JETTE VOHLERT"
        },
        {
          id: 2,
          type: "Left2Right",
          leftImage: "/images/kirker/2/left.jpg",
          leftImageHeight: 450,
          rightTopImage: "/images/kirker/2/right-top.jpg",
          rightTopImageHeight: 270,
          rightBottomImage: "/images/kirker/2/right-bottom.jpg",
          rightBottomImageHeight: 150,
          leftText: "VÅBENHUS SKRYDSTRUP KIRKE 2000",
          rightText: "BRONZESKULPTUR BÆNK OG DØRGREB BILLEDHUGGER JETTE VOHLERT"
        },
        {
          id: 3,
          type: "LeftRight",
          leftImage: "/images/kirker/3/left.jpg",
          rightImage: "/images/kirker/3/right.jpg",
          leftText: "STJERNEKRONE NØVLING KIRKE 2017",
          rightText: "I SAMARBEJDE MED BILLEDHUGGER JETTE VOHLERT"
        },
        {
          id: 4,
          type: "LeftRight",
          leftImage: "/images/kirker/4/left.jpg",
          rightImage: "/images/kirker/4/right.jpg",
          leftText: "STJERNEKRONE    VOR FRUE KIRKE    AARHUS  2022",
          rightText: "HELLIGÅNDSDUE   BILLEDHUGGER  JETTE VOHLERT"
        },
        {
          id: 5,
          type: "LeftRight",
          leftImage: "/images/kirker/5/left.jpg",
          rightImage: "/images/kirker/5/right.jpg",
          leftText: "PRÆSTETAVLER DÅBSKANDE DØBEFONTSRING GIVE KIRKE 2022",
          rightText: "I SAMARBEJDE MED BILLEDHUGGER JETTE VOHLERT"
        }
      ]
    };
  }
};
</script>
